export const iconFontAwesomeTextformattingAlignCenter = (
	<i className="fa-solid fa-align-center"></i>
);
